import React from 'react';

import { QueryRoute } from '@atlas/routing';

import ModalPortal from 'common/ModalPortal';
import Smartico from 'components/ClientProfile/Achievements/Smartico';
import EmailVerification from 'components/EmailVerification';
import ForgotPassword from 'components/ForgotPassword';
import { PopupSignUpDelay } from 'components/PopupSignUpDelay';
import ResetPassword from 'components/ResetPassword';
import SignIn from 'components/SignIn/SignIn';
import SingleSignUp from 'src/components/SignUp/SingleSignUp';

const QueryRoutes = () => (
  <>
    <QueryRoute command="signin">
      <ModalPortal>
        <SignIn />
      </ModalPortal>
    </QueryRoute>
    <QueryRoute command="signup-delay">
      <ModalPortal>
        <PopupSignUpDelay />
      </ModalPortal>
    </QueryRoute>
    <QueryRoute command="forgotPassword">
      <ModalPortal>
        <ForgotPassword />
      </ModalPortal>
    </QueryRoute>
    <QueryRoute command="resetPassword">
      <ModalPortal>
        <ResetPassword />
      </ModalPortal>
    </QueryRoute>
    <QueryRoute command="emailVerification">
      <ModalPortal>
        <EmailVerification />
      </ModalPortal>
    </QueryRoute>
    <QueryRoute command="resetPasswordPhone">
      <ModalPortal>
        <ResetPassword formType="PASSWORD_RESET_PHONE" />
      </ModalPortal>
    </QueryRoute>
    <QueryRoute command="achievements">
      <Smartico onlyModal={true} />
    </QueryRoute>
    <QueryRoute command="signup">
      <ModalPortal>
        <SingleSignUp />
      </ModalPortal>
    </QueryRoute>
  </>
);

export default QueryRoutes;
